import { useEffect } from "react";
import { api } from "@/lib/api";

// Injects auto-updating MusicAlbum/MusicRecording JSON-LD for any NEW releases
// catalogued on MusicBrainz (existing albums live in the static index.html graph).
// Mounted once, site-wide. Silently does nothing when there are no new releases.
export default function MusicAutoSchema() {
  useEffect(() => {
    let cancelled = false;
    api
      .get("/seo/music-jsonld")
      .then((r) => {
        const graph = r.data && r.data["@graph"];
        if (cancelled || !Array.isArray(graph) || graph.length === 0) return;
        const data = { "@context": "https://schema.org", "@graph": graph };
        let el = document.getElementById("music-jsonld");
        if (!el) {
          el = document.createElement("script");
          el.type = "application/ld+json";
          el.id = "music-jsonld";
          document.head.appendChild(el);
        }
        el.textContent = JSON.stringify(data);
      })
      .catch(() => {});
    return () => {
      cancelled = true;
    };
  }, []);
  return null;
}
